import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Estimate from "@/pages/Estimate";
import Contact from "@/pages/Contact";
import LocationPage from "@/pages/LocationPage";
import { LOCATIONS } from "@/data/locations";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Toaster richColors position="top-center" />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/estimate" element={<Estimate />} />
          <Route path="/contact" element={<Contact />} />
          {LOCATIONS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<LocationPage location={l} />} />
          ))}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
